export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10839.953f59be.jpg";